import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { customBlue } from "../../theme/palette";

interface Props {
  svg?: React.ComponentProps<typeof SvgIcon>;
  color?: string;
}

export const HumanSpeaking = (props: Props) => {
  const iconColor = props.color || customBlue.primaryBlue;

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      viewBox="0 0 24 20"
      {...props?.svg}
    >
      <path
        d="M3.95354 19.4714C4.38256 19.4714 8.10371 19.6144 10.9608 19.6144C10.2307 17.0921 11.8207 15.499 13.3474 15.499C14.8741 15.499 15.4716 15.2998 15.8035 14.7024C16.1354 14.105 15.7371 14.1299 15.8035 13.7731C15.8696 13.4181 16.1354 12.9101 16.1354 12.9101L15.0069 12.2463L16.1354 11.5826L15.8698 10.6533L16.3345 10.4542C16.3345 10.4542 16.6 10.3877 16.7328 10.0558C16.8655 9.72386 16.7328 9.52477 16.7328 9.52477L15.0069 7.43982C15.0069 7.43982 15.2978 6.38159 15.3388 5.87395C15.3982 5.13903 14.8078 3.81635 14.8078 3.81635C14.8078 3.81635 13.527 1.626 12.1526 1.02845C10.7782 0.430896 9.82931 0.16553 8.23628 0.165527C6.3919 0.271822 4.98373 0.49742 3.32431 1.4931C1.66489 2.48879 0.868306 4.59872 0.868306 4.59872C0.868306 4.59872 0.0193075 7.00243 0.868284 8.79465C1.20015 9.92308 2.06413 11.2522 2.19586 11.4498L2.19595 11.4499C2.32895 11.6494 3.08098 12.7775 3.32431 13.4411L3.78891 15.2334L3.95354 19.4714Z"
        fill={iconColor}
      />
      <path
        d="M18.5 11.0085C19.059 11.7946 19.0287 12.2125 18.5 13.0483"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="bevel"
        fill="none"
      />
      <path
        d="M19.6477 9.52979C21.198 11.4555 21.1139 12.4794 19.6477 14.5273"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="bevel"
        fill="none"
      />
      <path
        d="M21.1873 7.99988C23.635 10.6516 23.227 13.7113 21.1873 16.0571"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="bevel"
        fill="none"
      />
    </SvgIcon>
  );
};
